module.exports = __webpack_public_path__ + "assets/img/favicon/android-icon-48x48.071dc8083b84d84b306258a0c2e5c0ca.png";